import Bluetooth from '../images/Bluetooth.svg';
import Wifi from '../images/wifi.svg';
import Lora from '../images/LoRa.svg';
import Nbiot from '../images/nbiot_white.svg';
import Zigbee from '../images/Zigbee_logo.svg';
import Matter from '../images//matter.svg';

const Hero = () => {

    const handleScroll = (event, sectionId) => {
        event.preventDefault(); // Prevent default anchor behavior
    
        const section = document.getElementById(sectionId);
        if (section) {
          section.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      };
      
    return (
        <>
        <div className='sm:pb-72 lg:pb-44 sm:mt-28 lg:mt-24 2xl:mt-28'>
            <div className="bg-heroImage bg-cover bg-no-repeat sm:relative flex flex-col justify-center mx-4 sm:mx-12 rounded-xl lg:rounded-3xl">
                <div className="text-center place-items-center bg-[#17115080] p-6 pt-8 lg:pt-16 xl:pt-20 pb-8 sm:pb-16 lg:pb-28 xl:pb-32 rounded-xl lg:rounded-3xl">
                    
                        <h3 className="text-white font-uiBold text-base lg:text-xl xl:text-2xl leading-5">EMBEDDED SYSTEMS & IoT EXPERTS</h3>
                        <div className='my-6 lg:my-10'>
                            <h1 className="text-white font-symbol text-[2rem] sm:text-4xl lg:text-5xl xl:text-7xl leading-tight sm:pb-2">
                            Engineering the future of 
                            </h1>
                            <h1 className="text-[var(--powderblue)] font-symbol text-[2rem] sm:text-4xl lg:text-5xl xl:text-7xl leading-tight sm:pb-2">Connected Devices</h1>
                        </div>
                        <div className='flex m-auto justify-center'>
                        <p className="text-white text-center font-symbol text-base lg:text-xl xl:text-2xl lg:mt-8 w-11/12 sm:w-10/12 xl:w-9/12 2xl:w-6/12">
                            Specializing in custom firmware, embedded software development, and IoT solutions with
                            deep expertise in RF technologies and proprietary protocols.
                        </p>
                        </div>
                    
                    <div className="my-8 xl:my-12 flex justify-center flex-wrap gap-3">
                        <a href="#form" onClick={(e) => handleScroll(e, "form")}>
                            <button className="font-symbol font-semibold items-center justify-center px-9 py-3 overflow-hidden bg-white border-2 border-white text-[var(--kaizekblue)] text-base leading-5 rounded-xl hover:text-white hover:bg-[var(--slateblue)] hover:border-[var(--slateblue)] hover:shadow-md">
                            Start a project
                            </button>
                        </a>
                        <a href="#casestudies" onClick={(e) => handleScroll(e, "casestudies")}>
                            <button className="font-symbol font-semibold items-center justify-center px-9 py-3 overflow-hidden border-2 border-white text-white text-base leading-5 rounded-xl hover:text-[var(--kaizekblue)] hover:bg-white hover:shadow-md">
                            View our work
                            </button>
                        </a>
                    </div>
                </div>
                <div className='flex flex-col m-auto pb-4'>
                    <div className="sm:absolute sm:-translate-x-1/2 -bottom-64 sm:-bottom-[16.875rem] lg:-bottom-40 bg-[var(--slateblue)] text-white sm:mt-12 py-8 px-4 sm:p-4 xl:p-6 w-[88%] sm:w-11/12 xl:w-10/12 2xl:w-8/12 rounded-xl lg:rounded-3xl xl:rounded-[1.25rem] flex flex-col m-auto shadow-md lg:shadow-xl">
                        <div className="flex flex-col items-center">
                            <h3 className="text-[var(--whitetext)] pb-2 font-symbol sm:text-xl lg:text-2xl sm:mt-4 lg:mt-8">SUPPORTED TECHNOLOGIES</h3>
                            <div className='h-2 w-40 sm:w-48 border-b-4 border-[#f8f8f880] rounded-full sm:mb-4 lg:mb-8'></div>
                            <div className="grid grid-cols-2 lg:grid-flow-col gap-8 sm:gap-4 mt-8 mb-2 sm:my-8 items-center justify-center">
                                <div className='sm:pe-1 lg:pe-4 xl:pe-6 place-content-center flex'>
                                <img src={Bluetooth} alt='Bluetooth'></img>
                                </div>
                                <div className='sm:pe-1 lg:pe-4 xl:pe-6 place-content-center flex'>
                                <img src={Wifi} alt='Wifi'></img>
                                </div>
                                <div className='sm:pe-1 lg:pe-4 xl:pe-6 place-content-center flex'>
                                <img src={Lora} alt='Lora'></img>
                                </div>
                                <div className='sm:pe-1 lg:pe-4 xl:pe-6 place-content-center flex'>
                                <img src={Nbiot} alt='Nbiot'></img>
                                </div>
                                <div className='sm:pe-1 lg:pe-4 xl:pe-6 place-content-center flex'>
                                <img src={Zigbee} alt='Zigbee'></img>
                                </div>
                                <div className='place-content-center flex'>
                                <img src={Matter} alt='Matter'></img>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </>
    )
}

export default Hero